<div class="back-button" (click)="backClick.emit()">
    <mat-icon svgIcon="keyboard-arrow-left" class="align-middle"></mat-icon>
</div>
<div class="title">
    <div class="static" trans>Customizing</div>
    <div class="path">
        <ng-container *ngFor="let item of path; last as isLast; first as isFirst;">
            <span *ngIf="item">
                <mat-icon svgIcon="keyboard-arrow-right" class="separator align-middle size-18" *ngIf="!isFirst"></mat-icon>
                <span class="name" [class.last]="isLast">{{prettifyName(item)}}</span>
            </span>
        </ng-container>
    </div>
</div>